class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  async close(focusToggle = true) {
    if (this.isClosing || !this.isOpen()) return;
    this.isClosing = true;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    const modal = this.detailsContainer.querySelector('.search-modal');
    if (modal && !Theme.config.motionReduced) {
      await Theme.motion.animate(
        modal,
        { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-1.5rem)'] },
        { duration: 0.2, easing: 'ease' }
      ).finished;
    }

    this.detailsContainer.removeAttribute('open');
    modal?.getAnimations().forEach((animation) => animation.cancel());
    document.body.classList.remove('overflow-hidden');
    this.isClosing = false;
  }
}

customElements.define('details-modal', DetailsModal);
